import { ChevronRightIcon } from '@heroicons/react/24/outline';

// The trailing chevron on every brand-refresh "Label >" text link — the same Heroicons chevron the
// mobile menu uses, in place of a typed ">" so the arrow weight and alignment match the menu.
const CtaChevron = ({ className = '' }: { className?: string }) => (
  <ChevronRightIcon aria-hidden className={`ml-4 inline-block size-14 shrink-0 ${className}`} strokeWidth={2.25} />
);

export default CtaChevron;
